import TC from '../../TC';
import OfflineMapMaker from './OfflineMapMaker';
TC.control = TC.control || {};
TC.control.CacheBuilder = OfflineMapMaker;
const CacheBuilder = TC.control.CacheBuilder;
export default CacheBuilder;